// PastorsCarousel.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./Pastors.css";
import { FaFacebookF } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Pastor1 from "../assets/MeetPastors/Pastor1.png";
import Pastor2 from "../assets/MeetPastors/Pastor2.png";
import Pastor3 from "../assets/MeetPastors/Pastor3.png";
import Pastor4 from "../assets/MeetPastors/Pastor4.png"; 



const pastors = [
  {
    name: "Craig Groeschel",
    title: "Pastor",
    description:
      "Following a vision God gave him and his wife Amy for a different kind of church, he and a handful of people launched.",
    image: Pastor1,
  },
  {
    name: "Jerry Hurley",
    title: "Senior Priest",
    description:
      "Jerry is responsible for the team and cultural development and helps shape the overall direction and leadership of the church.",
    image: Pastor2,
  },
  {
    name: "Samantha Wiley",
    title: "Associate Pastor",
    description:
      "Samantha is passionate about exploring new ideas and finding practical ways to leverage them for the global Church.",
    image: Pastor3,
  },
  {
    name: "Michelle Dawson",
    title: "Youth Pastor",
    description:
      "Michelle leads the youth ministry and is dedicated to guiding young people on their spiritual journey with energy and compassion.",
    image: Pastor4, // Make sure to import Pastor4
  },
];


const Pastors = () => {
  return (
    <section className="section pastors" id="pastors">
      <div className="container has-text-centered">
        <h5 className="has-text-weight-bold is-3 main-title">Serving Our Saviour</h5>
        <h2 className="title is-3 main-title">Meet Our Pastors</h2>
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
        >
          {pastors.map((pastor, index) => (
            <SwiperSlide key={index}>
              <div className="pastor-card">
                <div className="pastor-image ">
                  <img src={pastor.image}  alt={pastor.name} />
                </div>
                <div className="pastor-social-icons">
                  <a href="#" className="icon" aria-label="Facebook">
                    <FaFacebookF color="white"/>
                  </a>
                  <a href="#" className="icon" aria-label="Email">
                    <MdEmail color="white"/>
                  </a>
                </div>

                <div className="pastor-details">
                  <p className="has-text-weight-bold is-size-5 has-text-black">
                    {pastor.name}
                  </p>
                  <p className="is-uppercase has-text-weight-semibold is-size-7 mb-2">
                    {pastor.title}
                  </p>
                  <p className="is-size-7 has-text-grey">
                    {pastor.description}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Pastors;
